// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/bLine.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/layer1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/layer2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/iframe-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.center_cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 5px);
    overflow: auto;
}

.models_card_image {
    max-width: 32px;
    min-width: 44.6px;
    margin: auto;
}

.tag_line_card {
    background: rgba(106, 106, 106, 1);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}

.model-row {
    margin-top: 20px;
    border-radius: 10px;
    border: 2px solid #dddddd;
    /* padding: 10px; */
    width: 40%;
    z-index: 1 !important; 
    cursor: pointer;

}

/* Create two equal columns that floats next to each other */
.models-column-left {
    display: flex;
    align-items: center;
    justify-content: center;
    float: left;
    width: 15%;
    padding: 10px;
    height: 131px;
    /* Should be removed. Only for demonstration */
}

.models-column-right {
    display: flex;
    /* align-items: center; */
    flex-direction: column;
    justify-content: center;
    float: left !important;
    width: 85%;
    padding-left: 10px;
    height: 131px;
    /* Should be removed. Only for demonstration */
}

/* Clear floats after the columns */
.model-row:after {
    content: "";
    display: table;
    clear: both;
}

/* Responsive layout - makes the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 1000px) {

    .models-column-left,
    .models-column-right {
        width: 100%;
    }
}

.radial-lines-card {
    position: absolute;
    top: 0;
    right: 0;
    width: 500px;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
}

.dots-card {
    position: absolute;
    bottom: 10px;
    left: 0;
    width: 400px;
    height: 28%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
}

.dots-card-2 {
    position: absolute;
    bottom: 100px;
    left: -20px;
    width: 190px;
    height: 50%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: cover;
}

.iframe-bg {
    position: absolute;
    bottom: 100px;
    left: -20px;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: cover;
}

.iframe-header {
    margin: 10px 0;
}

.iframe-header h4 {
    margin: 10px 0;
}

.iframe-bg p {
    color: #4E4E4E;
    font-weight: 100;
    font-size: 20px;
}

.iframe-input-container {
    display: flex;
    align-items: center;
    margin: 30px 0;
}

.iframe-input-container .iframe-text {
    font-size: 16px;
    color: #4E4E4E;
    width: 50px;
}

.iframe-input-container input {
    border-radius: 8px;
    height: 36px;
    padding-bottom:8px;
    margin: 0 5px;
}
.iframe-input-container .width {
    max-width: 80px;
    text-align: center;
}

.iframe-input-container .ant-select-selector {
    width: 140px !important;
    border-radius: 8px !important;
    height: 36px !important;
    margin: 0 4px;
}


.background-color-card {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
}

.models-buttons {
 margin-top: 20px;
 display: flex;
 justify-content: space-between;
 align-items: center;
 width: 40%;
}


.back-button .ant-btn{
    background: #fff !important;
    padding: 12px 30px !important;
    height: auto !important;
    border-radius: 6px !important;
}

@media screen and (max-width: 1200px) {
    .model-row, .models-buttons {
        width: 90%;
    }
}`, "",{"version":3,"sources":["webpack://./src/Screens/IFrame/IFrame.style.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,qBAAqB;IACrB,eAAe;;AAEnB;;AAEA,4DAA4D;AAC5D;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,UAAU;IACV,aAAa;IACb,aAAa;IACb,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,8CAA8C;AAClD;;AAEA,mCAAmC;AACnC;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA,uGAAuG;AACvG;;IAEI;;QAEI,WAAW;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,yDAA+C;IAC/C,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,YAAY;IACZ,WAAW;IACX,yDAAgD;IAChD,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,WAAW;IACX,yDAAgD;IAChD,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yDAAmD;IACnD,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,uBAAuB;IACvB,aAAa;AACjB;;;AAGA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,UAAU;AACX;;;AAGA;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":["\n.center_cont {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: calc(100vh - 5px);\n    overflow: auto;\n}\n\n.models_card_image {\n    max-width: 32px;\n    min-width: 44.6px;\n    margin: auto;\n}\n\n.tag_line_card {\n    background: rgba(106, 106, 106, 1);\n    -webkit-background-clip: text;\n    background-clip: text;\n    color: transparent;\n}\n\n.model-row {\n    margin-top: 20px;\n    border-radius: 10px;\n    border: 2px solid #dddddd;\n    /* padding: 10px; */\n    width: 40%;\n    z-index: 1 !important; \n    cursor: pointer;\n\n}\n\n/* Create two equal columns that floats next to each other */\n.models-column-left {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    float: left;\n    width: 15%;\n    padding: 10px;\n    height: 131px;\n    /* Should be removed. Only for demonstration */\n}\n\n.models-column-right {\n    display: flex;\n    /* align-items: center; */\n    flex-direction: column;\n    justify-content: center;\n    float: left !important;\n    width: 85%;\n    padding-left: 10px;\n    height: 131px;\n    /* Should be removed. Only for demonstration */\n}\n\n/* Clear floats after the columns */\n.model-row:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n\n/* Responsive layout - makes the two columns stack on top of each other instead of next to each other */\n@media screen and (max-width: 1000px) {\n\n    .models-column-left,\n    .models-column-right {\n        width: 100%;\n    }\n}\n\n.radial-lines-card {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 500px;\n    height: 100%;\n    background-image: url('../../assets/bLine.png');\n    background-size: cover;\n}\n\n.dots-card {\n    position: absolute;\n    bottom: 10px;\n    left: 0;\n    width: 400px;\n    height: 28%;\n    background-image: url('../../assets/layer1.png');\n    background-size: cover;\n}\n\n.dots-card-2 {\n    position: absolute;\n    bottom: 100px;\n    left: -20px;\n    width: 190px;\n    height: 50%;\n    background-image: url('../../assets/layer2.png');\n    background-size: cover;\n}\n\n.iframe-bg {\n    position: absolute;\n    bottom: 100px;\n    left: -20px;\n    width: 100%;\n    height: 100%;\n    background-image: url('../../assets/iframe-bg.png');\n    background-size: cover;\n}\n\n.iframe-header {\n    margin: 10px 0;\n}\n\n.iframe-header h4 {\n    margin: 10px 0;\n}\n\n.iframe-bg p {\n    color: #4E4E4E;\n    font-weight: 100;\n    font-size: 20px;\n}\n\n.iframe-input-container {\n    display: flex;\n    align-items: center;\n    margin: 30px 0;\n}\n\n.iframe-input-container .iframe-text {\n    font-size: 16px;\n    color: #4E4E4E;\n    width: 50px;\n}\n\n.iframe-input-container input {\n    border-radius: 8px;\n    height: 36px;\n    padding-bottom:8px;\n    margin: 0 5px;\n}\n.iframe-input-container .width {\n    max-width: 80px;\n    text-align: center;\n}\n\n.iframe-input-container .ant-select-selector {\n    width: 140px !important;\n    border-radius: 8px !important;\n    height: 36px !important;\n    margin: 0 4px;\n}\n\n\n.background-color-card {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.models-buttons {\n margin-top: 20px;\n display: flex;\n justify-content: space-between;\n align-items: center;\n width: 40%;\n}\n\n\n.back-button .ant-btn{\n    background: #fff !important;\n    padding: 12px 30px !important;\n    height: auto !important;\n    border-radius: 6px !important;\n}\n\n@media screen and (max-width: 1200px) {\n    .model-row, .models-buttons {\n        width: 90%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
